export const type_aplicaciones = {
    'OBLIGATORIO':0,
    'NO_OBLIGATORIO':1,
    'TODOS':2
}